import { render, staticRenderFns } from "./registerPlantationStep1.vue?vue&type=template&id=19bc731d"
import script from "./registerPlantationStep1.vue?vue&type=script&lang=js"
export * from "./registerPlantationStep1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports